<template>
    <div v-show="isLoadingFiles || files.length > 0" class="active-chat-asset-preview mx-2 my-0">
        <div v-for="asset in files" class="asset position-relative">
            <b-button
                v-if="selectedTemplate.assetIsLocked === 1"
                v-b-tooltip.hover.right="$t('upload.locked', { fileName: asset.originalName })"
                class="rounded-circle p-0 bg-transparent position-absolute d-block"
                variant="flat-secondary"
            >
                <font-awesome-icon :icon="['fas', 'lock']" size="sm" />
            </b-button>
            <b-button
                v-else
                v-b-tooltip.hover.right="$t('upload.unlink')"
                class="rounded-circle p-0 bg-white position-absolute d-block"
                variant="flat-secondary"
                @click="localRemoveFile(asset)"
            >
                <font-awesome-icon icon="times" size="sm" />
            </b-button>
            <div
                v-if="asset.contentType.match('image.*')"
                :key="asset.fileName"
                :style="{ 'background-image': 'url(' + getSrc(asset) + ')' }"
            />
            <div v-else>
                <font-awesome-icon :icon="resolveContentTypeIcon(asset.contentType)" size="2x" />
            </div>
        </div>

        <b-spinner v-if="isLoadingFiles" class="m-1" label="Loading..." variant="primary" />
    </div>
</template>

<script>
import { BContainer, BRow, BCol, BImg, BButton, BSpinner, VBTooltip } from "bootstrap-vue";
import { resolveContentTypeIcon } from "@/utils/chats";
import useFileUploads from "@/composables/useFileUploads";
import useActiveChatTemplates from "@/composables/useActiveChatTemplates";
import { getFullPath } from "@/utils/assets";

export default {
    components: {
        BContainer,
        BRow,
        BCol,
        BImg,
        BButton,
        BSpinner,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        isLoadingFiles: {
            type: Boolean,
            required: true,
        },
        files: {
            type: Array,
            required: true,
        },
    },
    setup() {
        const { getFiles, removeFile } = useFileUploads();
        const { selectedTemplate, hasMediaTemplateFilesUploaded } = useActiveChatTemplates();

        const localRemoveFile = (asset) => {
            removeFile(asset);

            if (getFiles.value.length === 0 && selectedTemplate.value.mediaType) {
                hasMediaTemplateFilesUploaded.value = false;
            }
        };

        const getSrc = (file) => {
            if (file.originalFileObject) {
                return URL.createObjectURL(file.originalFileObject);
            }

            return getFullPath(file);
        };

        return {
            resolveContentTypeIcon,
            getSrc,
            localRemoveFile,

            selectedTemplate,
        };
    },
};
</script>
